module.exports = __webpack_public_path__ + "static/media/car1.2065cdc9.jpg";